<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="bmTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("apps.ghistory") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
              {{ $t("apps.gticketchain") }}
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("apps.ghistory") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-4  mt-0">
                    <fieldset>
                      <div class="item">
                        <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                          <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                        </material-checkbox>
                        <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                          :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true"
                          month-name-format="long" :clearable="false" fluid :disabled="!time"
                          :text-input="textInputOptions" />
                      </div>
                    </fieldset>
                  </div>


                  <div class="col-lg-4 mt-2">
                    <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                    <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                      :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                      :clearable="false" fluid :disabled="!time" :text-input="textInputOptions" />
                  </div>

                  

                  <div class="col-lg-4 mt-2">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("content.masset") }}</label>
                    <select v-model="maincat_search" class="form-select">
                        <option value="">{{ $t("content.optall") }}</option>
                        <option v-for="(item, index) in listprint" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                    </select>
                  </div>

                  <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("apps.gtransaction") }}</label>
                    <MultiSelect v-model="tx_search" :options="tx_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid @change="changeTx"/>
                  </div>

                  <div v-if="tx_search.length !== tx_type.length && filterTx()" class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_mitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="3" variant="filled" fluid />
                  </div>

                  <div v-else class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_nomitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="5" variant="filled" fluid />
                  </div>

                   <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnchannel") }}</label>
                    <MultiSelect v-model="channel_search" :options="channel_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid  />
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <MultiSelect v-model="search_status" :options="status_type" optionLabel="name" filter
                          placeholder="" :maxSelectedLabels="4" variant="filled" fluid />
                  </div>

                  <!-- ปุ่ม Toggle -->
                  <div class="col-12 mt-2 text-center">
                    <hr class="horizontal dark my-2"> <!-- เส้นคั่นเบาๆ -->
                    <button type="button" class="btn btn-link text-primary p-0" @click="toggleAdvanced">
                      <i class="material-icons">
                        {{ showAdvanced ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                        {{ showAdvanced ? 'ซ่อนตัวเลือกเพิ่มเติม' : 'แสดงตัวเลือกเพิ่มเติม' }}
                    </button>
                  </div>

                  <transition name="fade">  
                    <div class="row m-0 p-0" v-show="showAdvanced">
                      <div class="col-lg-2 mt-3">
                        <label class="form-label ms-0">{{ $t("content.idcard") }}</label>
                        <MultiSelect v-model="idcard_search" :options="idcard_type" optionLabel="name" filter placeholder=""
                          :maxSelectedLabels="2" variant="filled" fluid />
                      </div>

                      <div class="col-lg-2 mt-3">
                        <label class="form-label ms-0">OTP</label>
                        <MultiSelect v-model="otp_search" :options="otp_type" optionLabel="name" filter placeholder=""
                          :maxSelectedLabels="2" variant="filled" fluid />
                      </div>

                      <div class="col-lg-3 mt-3">
                        <label class="form-label ms-0">{{ $t("content.autfingerprint") }}</label>
                        <MultiSelect v-model="represent_search" :options="represent_type" optionLabel="name" filter placeholder=""
                          :maxSelectedLabels="2" variant="filled" fluid />
                      </div>

                      <div class="col-lg-2 mt-3">
                        <label class="form-label ms-0">{{ $t("content.outage2") }}</label>
                        <MultiSelect v-model="outage_search" :options="outage_type" optionLabel="name" filter placeholder=""
                          :maxSelectedLabels="2" variant="filled" fluid />
                      </div>

                      <div class="col-lg-3 mt-2">
                        <fieldset>
                          <div class="item">
                            <label class="form-label ms-0">{{ $t("content.activewc") }}</label>
                            <div class="d-inline-block mx-2">
                              <material-checkbox id="activewc" v-model="ovdditem" :checked="ovdditem" :disabled="active_search?.length === 0  || active_search.length === active_type.length || active_search[0]?.code !== 'YES'">
                                {{ $t("content.tkovdue") }}
                              </material-checkbox>
                            </div>
                            <MultiSelect v-model="active_search" :options="active_type" optionLabel="name" filter placeholder=""
                            :maxSelectedLabels="2" variant="filled" fluid @change="ovdditem = false"/>
                          </div>
                        </fieldset>
                      </div>

                      
                      <div class="col-lg-3 mt-3">
                        <fieldset>
                          <div class="item">
                            <label class="form-label ms-0">{{ $t("content.amndeferitems") }}</label>
                            <div class="d-inline-block mx-2">
                              <material-checkbox id="activewc" v-model="ovditem" :checked="ovditem" :disabled="postpone_search?.length === 0  || postpone_search.length === postpone_type.length || postpone_search[0]?.code !== 'YES'">
                                {{ $t("content.deferovddate") }}
                              </material-checkbox>
                            </div>
                            <MultiSelect v-model="postpone_search" :options="postpone_type" optionLabel="name" filter placeholder=""
                            :maxSelectedLabels="2" variant="filled" fluid @change="ovditem = false"/>
                          </div>
                        </fieldset>
                      </div>

                      <div class="col-lg-2 mt-4">
                        <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                        <material-input type="text" v-model="tk_search" fluid/>
                      </div>

                      <div class="col-lg-2 mt-4">
                        <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                        <material-input type="text" v-model="stockno_search" fluid/>
                      </div>

                      <div class="col-lg-2 mt-4">
                        <label class="form-label ms-0">{{ $t("content.migraref") }}</label>
                        <material-input type="text" v-model="miref_search" fluid/>
                      </div>

                      <div class="col-lg-3 mt-4">
                        <label class="form-label ms-0">Serial Number</label>
                        <material-input type="text" v-model="serial_search" fluid/>
                      </div>
                    </div>
                  </transition>

                  
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                       <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="loadDataHistoryApi"
                        :disabled="(!time && cusName_search === '' && tk_search === '' && serial_search === '' && miref_search === '' && stockno_search === '') || monthDiff()
                        || (time && start_date > end_date) || type_search.length === 0 || tx_search.length === 0 || search_status.length === 0 || channel_search.length === 0
                        || otp_search.length === 0 || represent_search.length === 0 || idcard_search.length === 0 || outage_search.length === 0 || active_search.length === 0
                        || postpone_search.length === 0">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ search }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-end align-items-center">
                    <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                    <div>
                      <material-button id="pdfBtn" color="info" variant="outline"
                        class="float-lg-start float-sm-end mb-0 me-2" :disabled="listhistory.length === 0"
                        @click="pdfGen">
                        <i class="material-icons material-symbols-outlined">picture_as_pdf</i> pdf
                      </material-button>
                      <material-button id="excelBtn" color="info" variant="outline"
                        cclass="float-lg-start float-sm-end mb-0 me-2" :disabled="listhistory.length === 0"
                        @click="XlsxGen">
                        <i class="material-icons material-symbols-outlined">table_rows</i> Excel
                      </material-button>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.amnticketold") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.migraref") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.masset") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>
                            {{ $t("content.actpawn3") }} /
                            {{ $t("content.actpawn4") }}
                          </th>
                          <th>{{ $t("content.spedis") }}</th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnchannel") }}</th>
                          <th>{{ $t("content.assessor") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index"
                            :class="isPastToday(row) ? 'bg-danger-light' 
                            : (row.status === 'TERMINATE' ? 'bg-working' : '')">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.cusName }}
                            </span>
                            <span v-else>
                              {{ row.tkCusName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                          <td class="text-sm font-weight-normal" :style="row.outage ? 'color:red' : ''">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} (ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                  {{ checkTransaction(row.type) }} (ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} {{checkOutage('-',row.outage)}}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.catName }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.calDiscount) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span
                              v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                              <span v-if="row.payOrReceive === row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.type === 'INTEREST'">
                              <span v-if="row.payOrReceive !== row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.totalPay !== 0" style="color:red">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else-if="row.totalReceive !== 0" style="color:green">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.channel === 'SHOP'">
                              {{ $t("content.gchshop") }}
                            </span>
                            <span v-else>
                              LINE OA
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ checkProcess(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle" :title="chain"
                              @click="openListChain(row)">
                              <i class="material-icons material-symbols-outlined">arrow_forward</i>
                            </material-button>
                            <material-button color="dark" variant="outline" class="rounded-circle"
                              :title="t('buttons.printp')" @click="ticketGen(row)"
                              :disabled="row.type === 'REDEEM'
                                || (row.status === 'TERMINATE' && row.refNumber === '')">
                              <i class="material-icons material-symbols-outlined">print</i>
                            </material-button>
                            <material-button color="secondary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.printpb')"
                              @click="backCoverGen(row)" :disabled="row.type === 'PAWN' || row.status === 'TERMINATE'">
                              <i class="material-icons material-symbols-outlined">description</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="18" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header">
                          <td class="text-lg font-weight-bold text-end text-center" colspan="9">
                            <span v-if="listhistory.length > 0">
                              <b>{{ $t("content.gtotal") }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberString(totalQuantity) }}</b>
                            </span>
                          </td>

                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold" colspan="6"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 style="display: inline-block; width: auto">
                    {{ $t("apps.gticketchain") }}
                  </h5>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.trans") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.allprice") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listticketchain" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPageT - 1) * perPageT +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ทำแทน)
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ออนไลน์)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ออนไลน์)
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listticketchain.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="10" style="text-align: right">Total Rows : {{ totalRows_sT }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listticketchain.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageT" :total-items="totalRowsT"
                          :items-per-page="perPageT" @click="onClickHandlerT" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <!-- Search Customer Dialog -->
          <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <!-- <th style="width: 100px">{{ $t("content.ccode") }}</th> -->
                            <th>#</th>
                            <th>{{ $t("content.cnameth") }}</th>
                            <th>{{ $t("content.cnameen") }}</th>
                            <th>{{ $t("content.docno") }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerAfListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(row, index) in customerlist" :key="index" @click="selectCusAf(row)">
                            <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                            <td>{{ row.nameTh }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td colspan="2">{{ row.docNumber }}</td>
                          </tr>
                          <tr v-if="customerlist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>

                <div class="modal-footer">
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                            :items-per-page="perPageC" @click="onClickHandlerC" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          :workcaseDetail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
          :history="'yes'" 
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/>



        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, nextTick} from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue"
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MultiSelect from 'primevue/multiselect';
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDocumentStore } from '@/stores/document'
import { useShopStore } from '@/stores/shop'
import { useDepositStore } from '@/stores/deposit'
import { useCategoryStore } from '@/stores/category'


const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storep = usePaymentGroupStore()
const stored = useDocumentStore()
const storesh = useShopStore()
const storedepo = useDepositStore()
const storec = useCategoryStore()


const { t } = useI18n();
const swal = inject("$swal");


const exportFile = reactive([
  {
    cl: "info",
    cs: "me-2",
    ic: "picture_as_pdf",
    nm: "pdf",
    ac: "",
  },
  {
    cl: "info",
    cs: "",
    ic: "table_rows",
    nm: "excel",
    ac: "",
  },
]);


const cancel = computed(() => t("buttons.canc"));
const chain = computed(() => t('buttons.seed') + t("apps.gticketchain"));
const search = computed(() => t("buttons.sear"));

const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val);
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
  format: 'dd/MM/yyyy HH:mm'
};


const tx_type = ref([
  { name: t("content.cintrate1"), code: 'NORMAL' },
  { name: t("content.transmig"), code: 'MIGRATION' },
]);

const tx_mitype = ref([
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
]);

const tx_nomitype = ref([
  { name: t("content.actpawn1"), code: 'PAWN' },
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
  { name: t("content.actpawn5"), code: 'REDEEM' },
]);

const status_type = ref([
  { name: t("content.status_finish"), code: 'FINISH' },
  { name: t("content.status_freeze"), code: 'FREEZE' },
  { name: t("content.status_termi"), code: 'TERMINATE' },
  { name: t("content.status_breaking"), code: 'BREAKING' },
]);

const channel_type = ref([
  { name: t("content.gchshop"), code: 'SHOP' },
  { name: 'LINE OA', code: 'LINE_LIFF' },
]);

const idcard_type = ref([
  { name: t("content.usecard"), code: 'YES' },
  { name: t("content.donusecard"), code: 'NO' },
]);

const otp_type = ref([
  { name: t("content.useotp"), code: 'YES' },
  { name: t("content.donuseotp"), code: 'NO' },
]);

const represent_type = ref([
  { name: t("content.userepresent"), code: 'YES' },
  { name: t("content.donuserepresent"), code: 'NO' },
]);

const outage_type = ref([
  { name: t("content.useoutage"), code: 'YES' },
  { name: t("content.donuseoutage"), code: 'NO' },
]);

const active_type = ref([
  { name: t("content.onlyactivewc"), code: 'YES' },
  { name: t("content.postponecomp"), code: 'NO' },
]);


const postpone_type = ref([
  { name: t("content.amnstatusdefer"), code: 'YES' },
  { name: t("content.nvpostpone"), code: 'NO' },
]);


const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageT = ref(1);
const totalRowsT = ref(1);
const perPageT = ref(30);
const totalRows_sT = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')


const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const type_search = ref('');
const serial_search = ref('');
const search_status = ref('');
const tx_search = ref('');
const miref_search = ref('');
const stockno_search = ref('');
const active_search = ref('');
const shop_info = ref(null)
const channel_search = ref('');
const maincat_search = ref('');
const idcard_search = ref('');
const otp_search = ref('');
const represent_search = ref('');
const outage_search = ref('');
const postpone_search = ref('');

const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);

const showAdvanced = ref(false);
const listprint = ref([]);
const listhistory = ref([]);
const listticketchain = ref([]);
const listinfo = ref([]);
const customerlist = ref([])
const info_cat = ref('');
const workcaseDetail = ref(null);
const chain_uid = ref('');
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const time = ref(false);

const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const loading = ref(false);
const int_period = ref('');
const fcusdt = ref(false);
const dep_ref = ref('');
const promotionDetail = ref(null);
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);

const ovditem = ref(false);
const ovdrow = ref(false);
const ovdditem = ref(false);
const ovddrow = ref(false);


const key = JSON.parse(localStorage.getItem("shop_seleted"));


const onClickHandler = (page) => {
  // console.log('onClickHandler :' + page);
  updatePagination()
};


const onClickHandlerT = (page) => {
  updatePaginationT()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};

const checksessionStorage = async () => {
  const data = sessionStorage.getItem('historyPage');
  if (!data) return;

  const obj = JSON.parse(data);
  if (!obj) return;

  cancelBtn();
  time.value = true;
  start_date.value = new Date(obj.start_date);
  end_date.value = new Date(obj.end_date);
  
  // ค่าเริ่มต้นสำหรับสถานะ (Index 0 = เสร็จสิ้น)
  search_status.value = [status_type.value[0]];

  const configMap = {
    1:  { txIdx: 0, typeIdx: 'all', src: 'nomi' },
    2:  { txIdx: 1, typeIdx: 'all', src: 'mi'   },
    3:  { typeIdx: [0], src: 'nomi', fromReport: true }, // PAWN
    4:  { typeIdx: [1], src: 'nomi', fromReport: true }, // INTEREST
    5:  { typeIdx: [2], src: 'nomi', fromReport: true }, // INC_PRINCIPLE
    6:  { typeIdx: [3], src: 'nomi', fromReport: true }, // DEC_PRINCIPLE
    7:  { typeIdx: [4], src: 'nomi', fromReport: true }, // REDEEM
    8:  { txIdx: 1, typeIdx: [0],    src: 'mi'   }, 
    9:  { txIdx: 1, typeIdx: [1],    src: 'mi'   }, 
    10: { txIdx: 1, typeIdx: [2],    src: 'mi'   },
    11: { txIdx: 0, typeIdx: [0, 2], src: 'nomi' },
    12: { txIdx: 0, typeIdx: [1, 3, 4], src: 'nomi' },
    // มาจากหน้า Report
    21: { typeIdx: [0, 1, 2, 3], src: 'nomi', fromReport: true, isRedeemNew: true }, 
    22: { typeIdx: [0, 1, 2, 3], src: 'nomi', fromReport: true, isRemaining: true }
  };

  const nomiTypeMap = { 'PAWN': 0, 'INTEREST': 1, 'INC_PRINCIPLE': 2, 'DEC_PRINCIPLE': 3, 'REDEEM': 4 };
  const miTypeMap = { 'INTEREST': 0, 'INC_PRINCIPLE': 1, 'DEC_PRINCIPLE': 2 };

  // --- [CASE A]: 1-12 และ 21-22 ---
  if (configMap[obj.value]) {
    const cfg = configMap[obj.value];
    search_status.value = [status_type.value[0]];
    const source = cfg.src === 'nomi' ? tx_nomitype.value : tx_mitype.value;

    // เงื่อนไข: ถ้ามาจาก Report ให้เลือกทั้งหมด ถ้าไม่ใช่เลือกตาม index
    if (cfg.fromReport) {
      tx_search.value = tx_type.value; 
    } else {
      tx_search.value = [tx_type.value[cfg.txIdx]];
    }

    type_search.value = cfg.typeIdx === 'all' ? source : cfg.typeIdx.map(i => source[i]);

    // จัดการ Active Filter
    if (cfg.isRedeemNew) active_search.value = [active_type.value[1]]; 
    if (cfg.isRemaining) active_search.value = [active_type.value[0]];
  } 
  
  // --- [CASE B]: 13-19 (Logic เดิมของคุณ) ---
  else if (obj.value >= 13 && obj.value <= 19) {
    if (obj.value === 18 || obj.value === 19) {
      outage_search.value = outage_type.value;
      channel_search.value = channel_type.value;
    } else {
      const isOutageGroup = ['outage', 'outage-migration'].includes(obj.channel);
      outage_search.value = [outage_type.value[isOutageGroup ? 0 : 1]];
      channel_search.value = [channel_type.value[obj.channel === 'line' ? 1 : 0]];
    }

    let isMigration = (obj.value === 19) || (obj.value !== 18 && ['migration', 'outage-migration'].includes(obj.channel));
    tx_search.value = [tx_type.value[isMigration ? 1 : 0]];
    const source = isMigration ? tx_mitype.value : tx_nomitype.value;
    
    if (obj.value === 18 || obj.value === 19) {
      type_search.value = source;
    } else {
      const typeIdx = isMigration ? miTypeMap[obj.type] : nomiTypeMap[obj.type];
      if (typeIdx !== undefined) type_search.value = [source[typeIdx]];
    }

    const logicMap = { 13: { id: 0, otp: 1 }, 14: { id: 0, otp: 0 }, 15: { id: 1, otp: 1 }, 16: { id: 1, otp: 0 }, 18: { id: 2, otp: 0 }, 19: { id: 2, otp: 0 } };
    if (logicMap[obj.value]) {
      const cfg = logicMap[obj.value];
      idcard_search.value = cfg.id === 2 ? idcard_type.value : [idcard_type.value[cfg.id]];
      otp_search.value = [otp_type.value[cfg.otp]];
    } else if (obj.value === 17) {
      represent_search.value = [represent_type.value[0]];
    }
  }

  // --- [CASE C]: 23-25 (อายัด, ผลัด, หลุด จากหน้า Report) ---
  else if (obj.value >= 23 && obj.value <= 25) {
    // เลือกประเภทธุรกรรมทั้งหมดตามเงื่อนไขใหม่
    tx_search.value = tx_type.value; 
    type_search.value = tx_nomitype.value; 
    
    if (obj.value === 23) {
      search_status.value = [status_type.value[1]]; // อายัด
    } 
    else if (obj.value === 24) {
      search_status.value = [status_type.value[0]]; // เสร็จสิ้น
      if (typeof postpone_search.value !== 'undefined') {
        postpone_search.value = [postpone_type.value[0]]; // ผลัด (YES)
      }
    } 
    else if (obj.value === 25) {
      search_status.value = [status_type.value[3]]; // ของหลุด
    }
  }

  sessionStorage.removeItem('historyPage');
  await loadDataHistoryApi();
}


const toggleAdvanced = () => {
  showAdvanced.value = !showAdvanced.value;
};

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const onserachDate = () => {
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
};


const isPastToday = (row) => {
  if (!row) return false;

  // 1. เช็คคู่ที่ 1: ใช้ postponeDate
  const isOvdPairValid = ovditem.value === true && ovdrow.value === true;
  // 2. เช็คคู่ที่ 2: ใช้ dueDate
  const isOvddPairValid = ovdditem.value === true && ovddrow.value === true;

  let dateString = null;

  if (isOvdPairValid) {
    dateString = row.postponeDate;
  } else if (isOvddPairValid) {
    dateString = row.dueDate;
  } else {
    return false; // ถ้าไม่เข้าเงื่อนไขคู่ไหนเลย ไม่ต้องแสดงสีแดง
  }

  if (!dateString) return false;

  // 3. เปรียบเทียบวันที่
  const today = new Date().setHours(0, 0, 0, 0);
  const targetDate = new Date(dateString).setHours(0, 0, 0, 0);

  return targetDate < today;
};


function cancelBtn() {
  time.value = false;
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  serial_search.value = '';
  currentPage.value = 1
  listhistory.value = []
  listticketchain.value = []
  totalRows_s.value = ''
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  miref_search.value = ''
  stockno_search.value = ''
  maincat_search.value = ''
  active_search.value = active_type.value 
  type_search.value = tx_nomitype.value
  search_status.value = status_type.value
  tx_search.value = tx_type.value
  channel_search.value = channel_type.value
  idcard_search.value = idcard_type.value
  otp_search.value = otp_type.value
  represent_search.value = represent_type.value
  outage_search.value = outage_type.value
  postpone_search.value = postpone_type.value
  showAdvanced.value = false  
  ovditem.value = false
  ovdrow.value = false
  ovdditem.value = false
  ovddrow.value = false

}

function filterTx() {
  let process = false
  if (tx_search.value.length > 0) {
    let name = tx_search.value.filter((c) => c.code.trim() === 'MIGRATION');
    if (name.length > 0) {
      process = true
    }
  }
  return process
}


function changeTx() {
  // console.log("tx_search : " + tx_search.value);
  if (tx_search.value.length !== tx_type.value.length) {
    let txFilter = ''
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
    if (txFilter.includes("NORMAL")) {
      type_search.value = tx_nomitype.value;
    } else if (txFilter.includes("MIGRATION")) {
      type_search.value = tx_mitype.value;
    } else {
      type_search.value = '';
    }
  } else {
    type_search.value = tx_nomitype.value;
  }

}


function monthDiff() {
  // let diff = ''
  let pro = false
  // diff = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12 + (end_date.value.getMonth() - start_date.value.getMonth())
  // // diff = end_date.value.getMonth() - start_date.value.getMonth() +
  // //   (12 * (end_date.value.getFullYear() - start_date.value.getFullYear()))
  var months;
  months = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12;
  months += end_date.value.getMonth() - start_date.value.getMonth();

  if (time.value && months > 3) {
    pro = true
  }
  return pro
}

const loadDataHistoryApi = async () => {
  // console.log("start_date  : " + moment(new Date(start_date.value)).format('YYYY-MM-DDThh:mm:00') + " end_date : " + moment(new Date(end_date.value)).local());
  ovdrow.value = false
  ovddrow.value = false
  currentPage.value = 1
  let data = "";
  let sd = ''
  let ed = ''

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  let active = 'NONE'
  if (active_search.value.length !== active_type.value.length) {
    if (active_search.value[0].code.trim() === active_type.value[0].code.trim()) {
      active = 'TRUE'
    } else if (active_search.value[0].code.trim() === active_type.value[1].code.trim()) {
      active = 'FALSE'
    }
  }

  let postpone = 'NONE'
  if (postpone_search.value.length !== postpone_type.value.length) {
    if (postpone_search.value[0].code.trim() === postpone_type.value[0].code.trim()) {
      postpone = 'TRUE'
    } else if (postpone_search.value[0].code.trim() === postpone_type.value[1].code.trim()) {
      postpone = 'FALSE'
    }
  }


  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value,
    shopUid: key.uid,
    status: status,
    txFilter: txFilter,
    groupUid: key.groupUid,
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    active: active,
    channel: channel,
    catUid: maincat_search.value,
    idCardVerify: idcard,
    otp: otp,
    shopRepresent: represent,
    outage: outage,
    postpone: postpone,
    
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("loadHistory : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        if (postpone === 'TRUE') {
           ovdrow.value = true
        }
        if (active === 'TRUE') {
           ovddrow.value = true
        }
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


const loadDataPrintApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        // console.log('Listdata : ' + JSON.stringify(listprint.value))
      }
    }
  }
};


const setValue = async () => {
  type_search.value = tx_nomitype.value
  search_status.value = status_type.value
  tx_search.value = tx_type.value
  channel_search.value = channel_type.value
  idcard_search.value = idcard_type.value
  otp_search.value = otp_type.value
  represent_search.value = represent_type.value
  outage_search.value = outage_type.value
  active_search.value = active_type.value
  postpone_search.value = postpone_type.value

  await loadDataPrintApi()
  await checksessionStorage()
  
}

setValue()


async function getworkCaseInfo(id) {
  let data = "";
  data = {
    uid: id,
    groupUid: key.groupUid,
    shopUid: key.uid,
  };
  const payload = data;
  // console.log("workCaseInfo p : " + JSON.stringify(payload));
  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function getListChain() {
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
    shopUid: key.uid,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getListChain : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
      onClickTab('2')
    }
  }
}

async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }

  let cusUid = workcaseDetail.value.customerInfo.customerUid

  if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
     cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
  }
  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
      }
    }
  }
}


async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupInfoAdminFetch(payload);
  // console.log("detailPayment : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  }
  return side
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}


function containsOnlyNumbers(str){
  return /^\d+$/.test(str);
}

function checkOutage(str,val) { 
  let side = ''
  if (val) {
    if (str === ',') {
      side = str + t("content.outage")
    } else  if (str === '-') {
      side = '('+t("content.outage") + ')'
    }
    
  }
  return side
}

function checkShopRepresent(str,item) { 
  let side = ''
  if (item.outage === false) {
    if (str === ',') {
      side = str + t("content.gchonline")
    } else if (str === '-') {
      side = '(' + t("content.gchonline")
    }
  }

  
  if (containsOnlyNumbers(item.initRefNumber)) {
    if (side === '') {
      if (str === ',') {
          side = ','+t("content.translost")
        } else if (str === '-') {
          side = '('+t("content.translost")
        }
    } else {
      side = side + ','+t("content.translost")
    }
  }

  if (item.outage) {
      if (side === '') {
        if (str === ',') {
            side = str + t("content.outage")
          } else if (str === '-') {
            side = '(' + t("content.outage")
          }
      } else {
        side =  side + ','+t("content.outage")
      }
    }

  if (side !== '' && str === '-') {
    side = side + ')'
  }  

  return side
}



function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}




async function onClickTab(val) {
  if (val === '1') {
    if ((time.value && monthDiff()) || cusName_search.value !== '' && tk_search.value !== '' && serial_search.value !== '') {
      loadDataHistoryApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
  }
}


async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function selectCusAf(item) {
  // console.log('selectCusAf : ' + JSON.stringify(item));
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,
    groupUid: key.groupUid,
    shopUid: key.uid

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updatePagination() {
  ovdrow.value = false
  ovddrow.value = false
  listhistory.value = []
  let sd = ''
  let ed = ''

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  let active = 'NONE'
  if (active_search.value.length !== active_type.value.length) {
    if (active_search.value[0].code.trim() === active_type.value[0].code.trim()) {
      active = 'TRUE'
    } else if (active_search.value[0].code.trim() === active_type.value[1].code.trim()) {
      active = 'FALSE'
    }
  }

  let postpone = 'NONE'
  if (postpone_search.value.length !== postpone_type.value.length) {
    if (postpone_search.value[0].code.trim() === postpone_type.value[0].code.trim()) {
      postpone = 'TRUE'
    } else if (postpone_search.value[0].code.trim() === postpone_type.value[1].code.trim()) {
      postpone = 'FALSE'
    }
  }



  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value,
    shopUid: key.uid,
    status: status,
    txFilter: txFilter,
    groupUid: key.groupUid,
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    active: active,
    channel: channel,
    catUid:maincat_search.value,
    idCardVerify: idcard,
    otp: otp,
    shopRepresent: represent,
    outage: outage,
    postpone:postpone
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        if (postpone === 'TRUE') {
           ovdrow.value = true
        }
        if (active === 'TRUE') {
           ovddrow.value = true
        }
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function updatePaginationT() {
  listticketchain.value = []
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
    }
  }

}



async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,
    groupUid: key.groupUid,
    shopUid: key.uid

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
      await nextTick();
      document.getElementById("detailModal").click();
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}

async function getTicketImage() {
  images.value = []
  loading.value = true // เปิดสถานะโหลดไว้ก่อนเริ่มทำงาน

  // 1. กรองเอาเฉพาะรายการไฟล์ที่มี imageUid จริงๆ (ไม่เป็น "0")
  const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

  if (validFiles.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload ส่งหา API ส่วนกลาง
    const requests = validFiles.map((fileItem) => {
      const payload = {
        groupUid: key?.groupUid || "", // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
        shopUid: key?.uid || "",  // 🟢 ดึงจาก key.uid ตามสเปกดั้งเดิมของหน้านี้
        uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบ
      };
      // เรียกใช้ผ่านฟังก์ชัน store ส่วนกลางที่เราปรับปรุงเป็น POST ไว้เรียบร้อยแล้ว [INDEX]
      return stored.getFileFetch(payload); 
    });

    try {
      // 🟢 3. เปลี่ยนมาใช้ Promise.all ยิงดึงทุกไฟล์พร้อมกันแบบขนานรวดเดียว [INDEX]
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers) ของไฟล์ดิบชิ้นนี้
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;
              let fileType;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                fileType = 'application/pdf';
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else {
                // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                fileType = 'image/jpeg';
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const originalItem = validFiles[i];

              images.value.push({
                src: dataUrl,
                thumbnailImageSrc: dataUrl,
                alt: '',
                title: fileType, 
                filename: 'attachment_' + originalItem.imageUid, 
                uid: originalItem.uid,
                imageUid: originalItem.imageUid,
                rawBlob: cleanBlob 
              });
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all getTicketImage:", e);
      loading.value = false;
      return;
    }
  }

  // 🟢 4. แยกเส้นทางการพรีวิวและดาวน์โหลดตามประเภทไฟล์จริง (ดึงตัวแรกมาตัดสินใจ)
  if (images.value.length > 0) {
    const targetFile = images.value[0]; 
    const fileType = targetFile.title || "";
    const fileSrc = targetFile.src || "";

    if (fileType === 'application/pdf') {
      // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที
      loading.value = false;
      window.open(fileSrc, '_blank');

    } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
      // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมเปลี่ยนชื่อให้อ่านง่าย
      loading.value = false;
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
      let fileNameDownload = `excel_${today}.xlsx`;
      
      const link = document.createElement('a');
      link.href = fileSrc;
      link.setAttribute('download', fileNameDownload);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else {
      // 🖼️ กรณีเป็นรูปภาพปกติ -> ปิด Loading เพื่อให้ฟังก์ชันตัวนอกที่คุมเปิด Modal ทำงานต่อได้ตามฟลูเดิม
      loading.value = false;
    }

  } else {
    // 🟢 5. แผนสำรอง: กรณีไม่มีไฟล์แนบค้างอยู่จริง ให้สวมภาพ noImg แทนที่ตามดีไซน์เดิมของคุณ
    images.value.push({
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    });
    loading.value = false;
  }
}

async function openListChain(item) {
  chain_uid.value = item.uid
  currentPageT.value = 1
  listticketchain.value = []
  await getListChain()
}

async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: key.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


async function XlsxGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }


  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  let active = 'NONE'
  if (active_search.value.length !== active_type.value.length) {
    if (active_search.value[0].code.trim() === active_type.value[0].code.trim()) {
      active = 'TRUE'
    } else if (active_search.value[0].code.trim() === active_type.value[1].code.trim()) {
      active = 'FALSE'
    }
  }

  let postpone = 'NONE'
  if (postpone_search.value.length !== postpone_type.value.length) {
    if (postpone_search.value[0].code.trim() === postpone_type.value[0].code.trim()) {
      postpone = 'TRUE'
    } else if (postpone_search.value[0].code.trim() === postpone_type.value[1].code.trim()) {
      postpone = 'FALSE'
    }
  }


  data = {
    page: {
      index: "0",
      size: "0", // size=0 (default) = no page limit
      sort: ""
    },
    filter: {
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      fromDate: sd,
      toDate: ed,
      type: type,
      serialNumber: serial_search.value.trim(),
      shopUid: shop_info.value.uid,
      status: status,
      txFilter: txFilter,
      migrateRefNumber: miref_search.value.trim(),
      stockNumber: stockno_search.value.trim(),
      groupUid: shop_info.value.groupUid,
      active: active,
      shopName: shop_info.value.fullname,
      channel: channel,
      catUid: maincat_search.value,
      idCardVerify: idcard,
      otp: otp,
      shopRepresent: represent,
      outage: outage, 
      postpone:postpone
    }
  };

  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/workCase/history/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = `rpHistory_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function pdfGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  let active = 'NONE'
  if (active_search.value.length !== active_type.value.length) {
    if (active_search.value[0].code.trim() === active_type.value[0].code.trim()) {
      active = 'TRUE'
    } else if (active_search.value[0].code.trim() === active_type.value[1].code.trim()) {
      active = 'FALSE'
    }
  }

  let postpone = 'NONE'
  if (postpone_search.value.length !== postpone_type.value.length) {
    if (postpone_search.value[0].code.trim() === postpone_type.value[0].code.trim()) {
      postpone = 'TRUE'
    } else if (postpone_search.value[0].code.trim() === postpone_type.value[1].code.trim()) {
      postpone = 'FALSE'
    }
  }


  data = {
    page: {
      index: "0",
      size: "0", // size=0 (default) = no page limit
      sort: ""
    },
    filter: {
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      fromDate: sd,
      toDate: ed,
      type: type,
      serialNumber: serial_search.value.trim(),
      shopUid: shop_info.value.uid,
      status: status,
      txFilter: txFilter,
      migrateRefNumber: miref_search.value.trim(),
      stockNumber: stockno_search.value.trim(),
      groupUid: shop_info.value.groupUid,
      active: active,
      shopName: shop_info.value.fullname,
      channel: channel,
      catUid: maincat_search.value,
      idCardVerify: idcard,
      otp: otp,
      shopRepresent: represent,
      outage: outage, 
      postpone:postpone
    }
  };

  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/workCase/history/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function ticketGen(item) {
  let uids = []
  uids.push(item.uid)
  await getticketNew(uids)
}

async function backCoverGen(item) {
  let uids = []
  uids.push(item.uid)
  await getbackcoverNew(uids)
}


async function getticketNew(id) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    uids: id
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  console.log('ticket : ' + JSON.stringify(response));
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function getbackcoverNew(id) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    uids: id
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/backCover/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  console.log('backcover : ' + JSON.stringify(response));
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
        transdate_prv.value = workcase_prv.workItems[0].startTime
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: key.groupUid,
    shopUid: key.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}



onMounted(() => {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 20px !important;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

.bg-danger-light {
  background-color: #ffe5e5 !important; /* สีแดงอ่อน */
}

</style>
